export default "__VITE_ASSET__BFLCNbcX__"